import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { api, unwrap } from '@/api/client';
import type { components } from '@/api/schema';

export type StoreMembership = components['schemas']['StoreMembership'];
export type MyLicense = components['schemas']['MyLicense'];
export type PaymentMethods = components['schemas']['PaymentMethods'];
export type Quote = components['schemas']['Quote'];
export type CheckoutStatus = components['schemas']['CheckoutStatus'];
export type Ticket = NonNullable<CheckoutStatus['payment']>;

export const useTienda = () =>
  useQuery({
    queryKey: ['tienda'],
    queryFn: () => unwrap<StoreMembership[]>(api.GET('/api/v1/memberships')),
  });

export const useMisLicencias = () =>
  useQuery({
    queryKey: ['mis-licencias'],
    queryFn: () => unwrap<MyLicense[]>(api.GET('/api/v1/me/memberships')),
  });

export const useMetodosPago = () =>
  useQuery({
    queryKey: ['metodos-pago'],
    queryFn: () => unwrap<PaymentMethods>(api.GET('/api/v1/payments/methods')),
    staleTime: 5 * 60_000,
  });

/** Cotización del servidor (el cliente nunca calcula precios, plan §10.1). */
export function useCotizacion(membershipId: number, couponCode: string, scholarshipId?: number) {
  return useQuery({
    queryKey: ['cotizacion', membershipId, couponCode, scholarshipId],
    queryFn: () =>
      unwrap<Quote>(
        api.POST('/api/v1/checkout/quote', {
          body: {
            membershipId,
            ...(couponCode ? { couponCode } : {}),
            ...(scholarshipId ? { scholarshipId } : {}),
          },
        }),
      ),
    enabled: Number.isInteger(membershipId) && membershipId > 2,
    placeholderData: keepPreviousData,
    retry: false,
  });
}
